<div class="signature-field" dir="rtl">
  <div *ngIf="value" class="signature-preview">
    <div class="preview-copy">
      <span class="preview-icon" aria-hidden="true"><mat-icon>draw</mat-icon></span>
      <span><strong>پیش‌نمایش امضا</strong><small>امضای تحویل‌گیرنده</small></span>
    </div>
    <img [src]="imageUrl" alt="پیش‌نمایش امضای تحویل‌گیرنده" />
  </div>

  <ng-container *ngIf="!disabled; else readOnly">
    <div class="signature-instruction">
      <div><strong>محل امضا</strong><p>با انگشت یا ماوس در کادر زیر امضا کنید.</p></div>
      <span class="pen-icon" aria-hidden="true"><mat-icon>edit</mat-icon></span>
    </div>
    <div class="signature-surface" aria-label="محل رسم امضای تحویل‌گیرنده">
      <signature-pad #pad [options]="padOptions" (drawEnd)="onDrawEnd()"></signature-pad>
    </div>
    <div class="signature-actions">
      <span>امضا همراه تغییرات ذخیره می‌شود.</span>
      <button type="button" class="clear-signature" (click)="clear()"><mat-icon aria-hidden="true">restart_alt</mat-icon> پاک کردن</button>
    </div>
  </ng-container>
  <ng-template #readOnly><p *ngIf="!value" class="signature-empty">امضایی ثبت نشده است.</p></ng-template>
</div>
